export default {
  name: 'Bedroom',
  id: 'Bedroom',
  data: [
    // {
    //   title: 'A candle is burning close to the curtains.',
    //   icon1: '/static/svgs/first-floor-bedroom/candle.svg',
    //   answers: [
    //     'Make sure the fan isn’t turned on so that the curtains don’t blow into the flame.',
    //   ],
    //   correctAnswerIndex: 1,
    //   position: {
    //     x: -0.8,
    //     y: 0.2,
    //     z: 1.35
    //   },
    //   completed: false
    // },
    {
      title:
        'A space heater is directly next to the curtains, plugged into an extension cord.',
      icon1: '/static/svgs/first-floor-bedroom/bedroom-1.svg',
      answers: [
        'If you lose power, unplug electrical appliances to prevent potential damage from a power surge once electricity is restored.',
      ],
      correctAnswerIndex: 1,
      position: {
        x: 0.2,
        y: 0.2,
        z: 1.9
      },
      completed: false
    },
    // {
    //   title:
    //     'A patch of the ceiling is browning, revealing potential water damage.',
    //   icon1: '/static/svgs/first-floor-bedroom/brown-ceiling.svg',
    //   answers: [
    //     'Paint the ceiling so that it is no longer visible.',
    //   ],
    //   correctAnswerIndex: 2,
    //   position: {
    //     x: 1.25,
    //     y: 1,
    //     z: 0.5
    //   },
    //   completed: false
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/residential/firstFloor/Bedroom.js